import { render, staticRenderFns } from "./PolicyType7.vue?vue&type=template&id=0f5f994a&scoped=true"
import script from "./PolicyType7.vue?vue&type=script&lang=js"
export * from "./PolicyType7.vue?vue&type=script&lang=js"
import style0 from "./PolicyType7.vue?vue&type=style&index=0&id=0f5f994a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5f994a",
  null
  
)

export default component.exports